var map = {
	"./banner-carousel.de-CH.json": 1189,
	"./banner-carousel.de-DE.json": 1190,
	"./banner-carousel.en-CA.json": 1191,
	"./banner-carousel.en-GB.json": 1192,
	"./banner-carousel.en-IN.json": 1193,
	"./banner-carousel.en-ME.json": 1194,
	"./banner-carousel.en-US.json": 1195,
	"./banner-carousel.es-EM.json": 1196,
	"./banner-carousel.es-ES.json": 1197,
	"./banner-carousel.fr-BE.json": 1198,
	"./banner-carousel.fr-CA.json": 1199,
	"./banner-carousel.fr-CH.json": 1200,
	"./banner-carousel.nl-BE.json": 1201,
	"./banner-carousel.nl-NL.json": 1202,
	"./banner-carousel.pl-PL.json": 1203,
	"./banner-carousel.pt-BR.json": 1204
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1188;